import {
  Box,
  HStack,
  Icon,
  Show,
  Spinner,
  Text,
  ThemeColorPath,
  ThemeIconKey,
  VStack,
} from 'platform/foundation';
import {match} from 'ts-pattern';

import i18n from '@dms/i18n';

type ReportStatusLineTone = 'success' | 'warning' | 'informational';

export interface ReportStatusLineProps {
  label: string;
  value: string;
  tone: ReportStatusLineTone;
  icon: ThemeIconKey;
  isLoading?: boolean;
}

export function ReportStatusLine(props: ReportStatusLineProps) {
  const tone = props.isLoading ? 'informational' : props.tone;

  const tileBackgroundColor = match(tone)
    .returnType<ThemeColorPath>()
    .with('success', () => 'palettes.green.20.100')
    .with('warning', () => 'palettes.orange.20.100')
    .with('informational', () => 'palettes.blue.20.100')
    .exhaustive();

  const iconColor = match(tone)
    .returnType<ThemeColorPath>()
    .with('success', () => 'severity.success')
    .with('warning', () => 'severity.warning')
    .with('informational', () => 'severity.informational')
    .exhaustive();

  return (
    <Box backgroundColor="general.white" borderRadius="small" padding={2}>
      <HStack spacing={2} align="center" wrap="nowrap">
        <Box backgroundColor={tileBackgroundColor} borderRadius="small" padding={2}>
          <Icon size={6} value={props.icon} color={iconColor} />
        </Box>

        <VStack>
          <Text size="small" color="secondary">
            {props.label}
          </Text>
          <Show when={props.isLoading}>
            <HStack spacing={2} align="center">
              <Spinner size="small" />
              <Text size="base" color="secondary">
                {i18n.t('general.labels.loading')}
              </Text>
            </HStack>
          </Show>
          <Show when={!props.isLoading}>
            <Text size="base" color="primary">
              {props.value}
            </Text>
          </Show>
        </VStack>
      </HStack>
    </Box>
  );
}
